export class KetoParams {
  gender: string;
  age: number;
  weight: number;
  height: number;
  activity: number;
  fat: number;
  carbs: number;
  adjustment: number;
}

